"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var R = __importStar(require("../../utils/ramda"));
var useRandomGuid_1 = require("../../hooks/useRandomGuid");
var Field_1 = require("../../components/Field");
var Input_1 = require("../../components/Input");
var InputField = function (_a) {
  var id = _a.id,
    help = _a.help,
    secondaryHelp = _a.secondaryHelp,
    error = _a.error,
    _b = _a.onChange,
    onChange = _b === void 0 ? R.N : _b,
    value = _a.value,
    label = _a.label,
    labelTooltip = _a.labelTooltip,
    tooltipProps = _a.tooltipProps,
    containerProps = _a.containerProps,
    required = _a.required,
    restProps = __rest(_a, ["id", "help", "secondaryHelp", "error", "onChange", "value", "label", "labelTooltip", "tooltipProps", "containerProps", "required"]);
  var _c = __read((0, useRandomGuid_1.useRandomGuid)(), 1),
    guid = _c[0];
  return (0, jsx_runtime_1.jsx)(Field_1.Field, __assign({}, containerProps, {
    error: error,
    help: help,
    secondaryHelp: secondaryHelp,
    labelFor: id || guid,
    label: label,
    labelTooltip: labelTooltip,
    tooltipProps: tooltipProps,
    required: required
  }, {
    children: (0, jsx_runtime_1.jsx)(Input_1.Input, __assign({
      error: !!error,
      id: id || guid,
      value: value
    }, restProps, {
      onChange: function (e) {
        return onChange(e.currentTarget.value);
      }
    }))
  }));
};
exports.InputField = InputField;